import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { candidateApi } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    if (sessionStorage.getItem('mi_recruitment_logout_pending')) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await candidateApi.getProfile();
      if (data.success) {
        setUser(data.data);
      } else {
        setUser(null);
      }
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (credentials) => {
    sessionStorage.removeItem('mi_recruitment_logout_pending');
    const { data } = await candidateApi.login(credentials);
    if (data.success) {
      if (data.access_token) sessionStorage.setItem('mi_hrm_token', data.access_token);
      setUser(data.data);
    }
    return data;
  };

  const register = async (credentials) => {
    const { data } = await candidateApi.register(credentials);
    return data;
  };

  const logout = useCallback(async () => {
    sessionStorage.setItem('mi_recruitment_logout_pending', '1');
    sessionStorage.removeItem('mi_hrm_token');
    setUser(null);
    try {
      await candidateApi.logout();
    } catch {}
    window.location.href = '/login';
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
